module.exports = "<app-header></app-header>\r\n<div class=\"app-container\">\r\n  <router-outlet></router-outlet>\r\n</div>\r\n<app-footer></app-footer>"